import { cartCount, CART_CHANGED_EVENT } from '../../services/cart';
import { openCartDrawer } from '../shop/CartDrawer';
import { icon } from '../icons';

export interface MountedCartButton {
  el: HTMLButtonElement;
  destroy(): void;
}

// createCartButton builds a cart button with a live item-count badge for the
// nav. variant 'top' = the desktop top-nav control; 'tab' = a phone tab-bar
// button. It opens the cart drawer on click and refreshes the badge on
// CART_CHANGED (and on creation); destroy() removes the listener.
export function createCartButton(variant: 'top' | 'tab'): MountedCartButton {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = variant === 'tab' ? 'tabbar__item cart-tab' : 'cart-btn';

  const glyph = document.createElement('span');
  glyph.className = variant === 'tab' ? 'tabbar__icon cart-btn__glyph' : 'cart-btn__glyph';
  glyph.appendChild(icon('cart'));

  const badge = document.createElement('span');
  badge.className = 'cart-btn__badge';
  badge.hidden = true;
  glyph.appendChild(badge);
  btn.append(glyph);

  if (variant === 'tab') {
    const label = document.createElement('span');
    label.textContent = 'Cart';
    btn.append(label);
  }

  btn.addEventListener('click', () => openCartDrawer());

  const refresh = (): void => {
    void cartCount().then((n) => {
      badge.textContent = String(n);
      badge.hidden = n <= 0;
      btn.setAttribute('aria-label', n > 0 ? `Open cart, ${n} item${n === 1 ? '' : 's'}` : 'Open cart');
    });
  };
  window.addEventListener(CART_CHANGED_EVENT, refresh);
  refresh();

  return {
    el: btn,
    destroy() {
      window.removeEventListener(CART_CHANGED_EVENT, refresh);
    },
  };
}
